import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmacaoComponent } from '@components/dialog-confirmacao/dialog-confirmacao.component';

import { ComodoModelo } from '../../../editar-modelo-vistoria/models/comodo-modelo';
import { ItemVistoriaModelo } from '../../../editar-modelo-vistoria/models/item-vistoria-modelo';
import { ComodoVistoriaPreenchimento } from '../../models/comodo-vistoria-preenchimento';

@Component({
  selector: 'app-comodos-vistoria',
  standalone: false,
  templateUrl: './comodos-vistoria.component.html',
  styleUrl: './comodos-vistoria.component.scss'
})
export class ComodosVistoriaComponent {

  @Input() comodosModelo: ComodoModelo[] = [];
  @Input() itensModelo: ItemVistoriaModelo[] = [];
  @Input() comodosVistoria: ComodoVistoriaPreenchimento[] = [];
  @Input() vistoriaId = 0;
  @Input() editarModelo = false;

  /** Mantém os painéis do accordion quando a tela troca o array pelo devolvido no salvar. */
  public trackPorIndice(indice: number): number {
    return indice;
  }

  constructor(private dialog: MatDialog) { }

  public adicionarComodo(comodo: ComodoModelo | null): void {
    if (!comodo) return;

    const quantidadeExistente = this.comodosVistoria.filter(c => c.comodoModeloId === comodo.id).length;

    this.comodosVistoria.push({
      id: 0,
      comodoModeloId: comodo.id,
      tipo: comodo.nome,
      nome: `${comodo.nome} ${quantidadeExistente + 1}`,
      itensModelo: comodo.itens,
      itens: [],
    });
  }

  public adicionarComodoAvulso(): void {
    this.comodosVistoria.push({
      id: 0,
      comodoModeloId: null,
      tipo: '',
      nome: '',
      itensModelo: [],
      itens: [],
    });
  }

  public confirmarRemocao(comodo: ComodoVistoriaPreenchimento): void {
    const dialogRef = this.dialog.open(DialogConfirmacaoComponent, {
      width: '467px',
      panelClass: 'no-padding-dialog',
      disableClose: true,
    });
    dialogRef.componentInstance.titulo = 'Remover cômodo';
    dialogRef.componentInstance.mensagem = `O cômodo "${comodo.nome || '-'}" será removido.`;
    dialogRef.componentInstance.textoBtnConfirmacao = 'Remover';
    dialogRef.componentInstance.btnBackgroundColor = '#F44336';
    dialogRef.componentInstance.acaoConfirmacao = () => this.removerComodo(comodo);
  }

  private removerComodo(comodo: ComodoVistoriaPreenchimento): void {
    this.comodosVistoria.splice(this.comodosVistoria.indexOf(comodo), 1);
  }
}
